import type { MouseEvent } from 'react';

// ExternalStatusIcon v0.1.1 — Phase 2D click-vs-icon split.
// Renders a discrete `↗` glyph that opens the upstream status page in a new
// tab. Critically, the click handler stops propagation so the surrounding
// card body's click handler (which opens a description tooltip/modal) does
// not also fire. Touch hit target is 32×32 and high-contrast so the affordance
// is visible even inside dense provider cards.
interface Props {
  href: string;
  // For aria-label, e.g. "Open AWS status page".
  label: string;
  onClick?: (e: MouseEvent) => void;
}

export default function ExternalStatusIcon({ href, label, onClick }: Props) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        // Critical: card body has its own click handler. Without
        // stopPropagation a tap on the icon would both navigate AND open
        // the description popup.
        e.stopPropagation();
        onClick?.(e);
      }}
      aria-label={label}
      className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-accent/70 bg-accent/15 text-accent hover:bg-accent hover:text-bg transition-colors text-base font-bold leading-none"
    >
      ↗
    </a>
  );
}
